import { BAOCustomElement } from '@bao/custom-element'
import { eventBus, EVENTS } from '@bao/events'
import { sectionRenderer } from '@bao/section-rendering'

class CartCount extends BAOCustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onCartChanged = this.onCartChanged.bind(this)

    eventBus.addEventListener(EVENTS.PUSH_CART.CHANGED, this.onCartChanged)
  }

  /**
   * @param {CustomEvent} e
   *
   * @returns {void}
   */
  onCartChanged (e) {
    const { state } = e.detail
    if (!state) return

    this.updateEmarsys(state)

    if (!state.sections) return

    if (!('push-cart-count' in state.sections)) return

    const newCartTotal = parseInt(
      this.getCount(state.sections['push-cart-count']),
    )

    this.textContent = this.getCount(state.sections['push-cart-count'])
    this.setAttribute('aria-hidden', newCartTotal === 0)
  }

  /**
   * @param {string} html
   *
   * @returns {string}
   */
  getCount (html) {
    const DOM = sectionRenderer.convertToDOM(html)

    return DOM.querySelector('#push-cart-count').textContent
  }

  updateEmarsys (cart) {
    if (!document.body.dataset.emarsysMerchantId) return

    const eventCart = cart.items.map((item) => {
      return {
        item: item.sku || item.product_id,
        price: item.final_line_price / 100,
        quantity: item.quantity,
      }
    })

    window.ScarabQueue.push(['cart', eventCart])
    window.ScarabQueue.push(['go'])
  }
}

if (!customElements.get('cart-count')) {
  customElements.define('cart-count', CartCount)
}
